import axios from 'axios';
import { useSetAtom } from 'jotai';
import useSWR from 'swr';
import { loaderState } from '../atoms/utilsAtoms';
import { useEffect } from 'react';
import { redirectToLoginForAuthFailure } from '../utils/authCleanup';

const fetcher = async ({ url, token = '' }) => {
	// eslint-disable-next-line no-useless-catch
	try {
		axios.defaults.withCredentials = true;
		if (token?.trim()?.length === 0) {
			return axios.get(url).then(res => res.data);
		}
		return axios.get(url, { headers: { Authorization: 'Bearer ' + token, deviceOrigin: 'web' } }).then(res => res.data);
	} catch (error) {
		throw error;
	}
};

/**
 *
 * @param {String} address - API URL
 * @returns SWR response with error handling
 */
export const useSwrData = (address, token = '', options = {}) => {
	const setLoader = useSetAtom(loaderState);

	const { data, error, isLoading, mutate } = useSWR(token === undefined ? null : { url: address, token }, fetcher, {
		...options,
		onError: error => {
			if (error.response?.status === 401) {
				redirectToLoginForAuthFailure();
			}
			setLoader(false);
		}
	});

	useEffect(() => {
		setLoader(isLoading);
	}, [isLoading, setLoader]);

	useEffect(() => {
		if (error) {
			console.error('[SWR ERROR]', error);
			setLoader(false);
		}
	}, [error, setLoader]);

	return { data, error, isLoading, mutate };
};
